/*
 * Copyright (c) 2019 by Orange Polska S.A.
 * This software is the proprietary information of Orange Polska S.A.
 *
 * All rights reserved.
 */

"use strict";
(function(global) {
    class CybertarczaThreatManagerResponseListController {
        constructor(config) {
            this.settings = {
                table: {
                    id: 'grid-container'
                }
            };
            this.init(config);
        };

        init(config) {
            this.createGrid(config);
        }

        createGrid(config) {
            const columnDefinitionSource = new NS.Grid.SimpleColumnDefinitionSource({
                "columnDefinitions": [{
                    "label": "Id",
                    "dataIndex": "id",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "isMovable": true,
                    "width": "*"
                }, {
                    "label": "Id żądania",
                    "dataIndex": "request_id",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "width": "*"
                }, {
                    "label": "Adres IP",
                    "dataIndex": "source_ip",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "width": "*"
                }, {
                    "label": "Status odpowiedzi",
                    "dataIndex": "response_status",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "width": "*"
                }, {
                    "label": "Data utworzenia",
                    "dataIndex": "created_at",
                    "dataType": "text",
                    "isEditable": false,
                    "isSortable": true,
                    "isFilterable": true,
                    "width": "*"
                }, {
                    "label": "Akcje",
                    "dataIndex": "actions",
                    "dataType": "actions",
                    "isFilterable": false,
                    "isSortable": false,
                    "isEditable": false,
                    "width": "*"
                }]
            });

            const dataSource = new NS.Grid.SimpleDataSource({
                'url': config['table_data_url'],
                'baseParameters': {},
                'updateUrl': "/js/app/update.json"
            });
            const settingsManager = new NS.Grid.CookiesSettingsManager({
                "id": "gridContainerId"
            });
            new NS.Grid.Control({
                'id': "gridContainerWrapperId",
                'containerId': this.settings['table']['id'],
                'dataSource': dataSource,
                'reloadTime': null, //not implemented yet
                'autoLoad': true,
                'columnDefinitionSource': columnDefinitionSource,
                'settingsManager': settingsManager,
                'allowMultiselect': false,
                "showAllRows" : false,
                "pageSize": (config.show_all_rows)? 99999999 : 20,
                'listeners': {
                    'onDataChanged': function() {

                    },
                    'onDataSaved': function() {

                    },
                    'onDataInvalid': function() {

                    },
                    'onDataError': function() {

                    },
                    'onSelectionChange': function(ids) {

                    }
                }
            });
        }
    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Views = global.NS.Views || {};
    global.NS.Views.CyberTarczaThreatManagerResponseListController = CybertarczaThreatManagerResponseListController || {};

})(window);
